import React from "react";

export const AuthContext = React.createContext({
    user: null,
    userProfile: null,
    loading: true,
    error: null,
    logout: () => { },
    updateUserProfile: () => { },
    isAdmin: false,
    isStudent: false,
    isStartup: false
});

export default AuthContext;
